import { mapGetters } from 'vuex';
import axiosvl from "../axios/axios-vl.js";

export default {
    computed: {
        ...mapGetters([
            'customerIndicator',
            'storefrontAttributes'
        ]),
        mx_product_showStockDisplay() {
            let result = true;
            let obj = this.storefrontAttributes.find(attribute => attribute.indicator === this.customerIndicator && attribute.type === 'OHQ');
            if (obj != undefined) {
                if (obj.value === '1' || obj.value === '2' || obj.value === '3' || obj.value === '6') {
                    result = true;
                } else {
                    result = false;
                }
            }

            return result;
        },
    },

    methods: {
        mx_product_details(mfgc, item) {
            // console.log('called getProductDetails');
            this.isloading = true;
            const wd_mdfgs = this.$store.getters.wd_mfgs;

            return axiosvl.post(this.$store.getters['api/product_details_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "EIMFGC": { "value": mfgc },
                        "EIITMC": { "value": item },
                    },   
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;
                // console.log(fields);
                const xref_mfg_desc = wd_mdfgs.find(mfg => mfg.MFG_CODE == fields.XRMFGC.value);
                this.isloading = false;

                return {
                    sku: fields.IMITMC.value,
                    desc: fields.IMDESC.value,
                    manufacturer: fields.IMMFGC.value,
                    manufacturername: fields.MCNAME.value,
                    location: fields.CMDLOC.value,
                    // Based on Nic's comments on Issue #32 - Prices for a part in DMS depend on the Customer signed in (EHCUST) (assumptions made that some field names are incorrect)
                    // Price: EIECP
                    // Core Price: EICORP
                    // List Price: EILISTP (if setup for the customer)
                    price: fields.EIEXCP.value,
                    coreprice: fields.EICORP.value,
                    listprice: fields.EILSTP.value,
                    XRITMC: fields.XRITMC.value,
                    XRMFGC: fields.XRMFGC.value,
                    xref_mfg_desc: (fields.XRMFGC.value != '') ? xref_mfg_desc.MFG_DESC : '',
                    IMIGSA: fields.IMIGSA.value,
                    IMISVALID: fields.IMISVALID.value,
                    stockquantity: (this.$store.getters.customerIndicator == 'B') ? fields.QTYAVL.value : fields.TOTOH.value,
                    gallery: []
                };
                
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });

        },

        mx_category_uri(category){
            console.log(category);
            const st_categories = this.$store.getters['product/categories'];
            const level = category.categorylevel;
            const childlvl = level + 1;

            const child_cats = st_categories.filter((cat) => {
                switch (level){
                    case 2:
                        return ((cat.DMCD01 === category.DMCD01) && (cat.DMCD02 === category.DMCD02) && (cat.categorylevel === childlvl));
                    case 3:
                        return ((cat.DMCD01 === category.DMCD01) && (cat.DMCD02 === category.DMCD02)  && (cat.DMCD03 === category.DMCD03) && (cat.categorylevel === childlvl));
                    case 4:
                        return ((cat.DMCD01 === category.DMCD01) && (cat.DMCD02 === category.DMCD02)  && (cat.DMCD03 === category.DMCD03) && (cat.DMCD04 === category.DMCD04) && (cat.categorylevel === childlvl));
                    case 5:
                        return ((cat.DMCD01 === category.DMCD01) && (cat.DMCD02 === category.DMCD02)  && (cat.DMCD03 === category.DMCD03) && (cat.DMCD04 === category.DMCD04) && (cat.DMCD05 === category.DMCD05) && (cat.categorylevel === childlvl));
                    case 6:
                        return ((cat.DMCD01 === category.DMCD01) && (cat.DMCD02 === category.DMCD02)  && (cat.DMCD03 === category.DMCD03) && (cat.DMCD04 === category.DMCD04) && (cat.DMCD05 === category.DMCD05) && (cat.DMCD06 === category.DMCD06) && (cat.categorylevel === childlvl));
                    case 7:
                        return ((cat.DMCD01 === category.DMCD01) && (cat.DMCD02 === category.DMCD02)  && (cat.DMCD03 === category.DMCD03) && (cat.DMCD04 === category.DMCD04) && (cat.DMCD05 === category.DMCD05) && (cat.DMCD06 === category.DMCD06) && (cat.DMCD07 === category.DMCD07) && (cat.categorylevel === childlvl));
                    case 8:
                        return ((cat.DMCD01 === category.DMCD01) && (cat.DMCD02 === category.DMCD02)  && (cat.DMCD03 === category.DMCD03) && (cat.DMCD04 === category.DMCD04) && (cat.DMCD05 === category.DMCD05) && (cat.DMCD06 === category.DMCD06) && (cat.DMCD07 === category.DMCD07) && (cat.DMCD08 === category.DMCD08) && (cat.categorylevel === childlvl));
                    case 9:
                        return ((cat.DMCD01 === category.DMCD01) && (cat.DMCD02 === category.DMCD02)  && (cat.DMCD03 === category.DMCD03) && (cat.DMCD04 === category.DMCD04) && (cat.DMCD05 === category.DMCD05) && (cat.DMCD06 === category.DMCD06) && (cat.DMCD07 === category.DMCD07) && (cat.DMCD08 === category.DMCD08) && (cat.DMCD09 === category.DMCD09) && (cat.categorylevel === childlvl));
                    case 10:
                        return ((cat.DMCD01 === category.DMCD01) && (cat.DMCD02 === category.DMCD02)  && (cat.DMCD03 === category.DMCD03) && (cat.DMCD04 === category.DMCD04) && (cat.DMCD05 === category.DMCD05) && (cat.DMCD06 === category.DMCD06) && (cat.DMCD07 === category.DMCD07) && (cat.DMCD08 === category.DMCD08) && (cat.DMCD09 === category.DMCD09)  && (cat.DMCD10 === category.DMCD10) && (cat.categorylevel === childlvl));
                }
            });

            let params = '';
            let l = 1;
            if ((child_cats.length > 0) && (level < 10)){
                params = '/category/'+level;
                while (l <= level){
                    if(l < 10){
                        params += '/' + category['DMCD0' + l];
                    }else{
                        params += '/' + category['DMCD10'];
                    }
                    l++;
                }
            }else{
                params = '/sub-category/'+level;
                while (l <= level){
                    if(l < 10){
                        params += '/' + category['DMCD0' + l];
                    }else{
                        params += '/' + category['DMCD10'];
                    }
                    l++;
                }
            }

            // let ln = 1;
            // while (ln <= level){
            //     const curr_cat = this.fetchCatDetails(ln);
            //     // console.log(curr_cat);
            //     params += '/' + curr_cat[0].categoryname.replace(/ /g, '-');
            //     ln++;
            // }

            return params;
        }
    }
};